'use strict';
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/deprecation-decorator/node_modules/core-js/internals/use-symbol-as-uid.js
// module id = 2798
// module chunks = 25